import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "build",
  "use": "build-usage",
  "viewBox": "0 0 20.01 17.5",
  "content": "<symbol viewBox=\"0 0 20.01 17.5\" id=\"build\"><title>build</title><path id=\"build__矩形_\" data-name=\"&lt;矩形&gt;\" d=\"M.37,3.62H9.86a5.44,5.44,0,0,1,5.44,5.44v.07a.78.78,0,0,1-.78.78H.37A.78.78,0,0,1-.4,9.12V4.39A.78.78,0,0,1,.37,3.62Z\" transform=\"translate(-2.59 6) rotate(-45)\" /><path id=\"build__矩形_2\" data-name=\"&lt;矩形&gt;\" d=\"M13.48,6.33h2.35a0,0,0,0,1,0,0v13a1.16,1.16,0,0,1-1.16,1.16h0a1.16,1.16,0,0,1-1.16-1.16v-13a0,0,0,0,1,0,0Z\" transform=\"translate(-5.18 13.05) rotate(-45)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/build.svg
// module id = WmWN
// module chunks = 264